import { ColorDynamic, VisibilityObserver } from '@superdispatch/ui';
import styled from 'styled-components';
import { ReactNode } from 'react';

export const ShipperReportContent = styled.div`
  display: flex;
  width: 100%;
  padding: 16px 24px;

  & form {
    width: 100%;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    padding: 16px 32px;
  }
`;

const ActionsContainer = styled.div<{ stuck: boolean }>`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 65px;
  padding: 0 24px;

  position: sticky;
  top: auto;
  bottom: 0;

  background-color: ${ColorDynamic.White};
  border-top: 1px solid
    ${({ stuck }) =>
      stuck ? ColorDynamic.Silver400 : ColorDynamic.Transparent};

  ${({ theme }) => theme.breakpoints.up('md')} {
    padding: 0 32px;
  }
`;

interface ActionsProps {
  children: ReactNode;
}

export function ShipperReportActions({ children }: ActionsProps) {
  return (
    <VisibilityObserver
      render={({ ref, visibility }) => (
        <>
          <ActionsContainer stuck={visibility === 'invisible'}>
            {children}
          </ActionsContainer>
          <div ref={ref} />
        </>
      )}
    />
  );
}
